<template>
  <v-container fluid class="vehicle-add-page mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-stepper v-model="step" class="transparent elevation-0">
          <v-card class="mb-5">
            <v-stepper-header >
              <v-stepper-step :complete="step > 1" step="1">Vehicle Information</v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step :complete="step > 2" step="2">Photo</v-stepper-step>
            </v-stepper-header>
          </v-card>

          <v-card>
            <v-stepper-items>
              <v-stepper-content step="1">
                <v-card>
                  <v-row justify="center">
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">Create New Vehicle</p>
                        <v-text-field
                          class="mb-4"
                          v-model="vehicle.vehiclecode"
                          v-bind:error="errorindex == 0"
                          outlined
                          dense
                          placeholder="Vehicle Code"
                          persistent-hint
                          single-line hint="Enter the vehicle Code">
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="vehicle.vehiclename"
                          v-bind:error="errorindex == 1"
                          outlined
                          dense
                          placeholder="Vehicle Name"
                          persistent-hint
                          single-line hint="Enter the vehicle name">
                        </v-text-field>
                        <v-select
                          class="mb-4"
                          :items=items
                          v-model="vehicle.vehicletype"
                          v-bind:error="errorindex == 2"
                          outlined
                          dense
                          placeholder="Type"
                          persistent-hint
                          single-line hint="Please choose the vehicle type">
                        </v-select>
                          <v-switch
                            v-model="vehicle.vehiclestatus"
                            color="primary"
                            v-bind:label="vehicle.vehiclestatus"
                            value="Active"
                          ></v-switch>
                      </v-form>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">&nbsp;</p>
                        <v-text-field
                          class="mb-4"
                          v-model="vehicle.vehiclemodel"
                          v-bind:error="errorindex == 3"
                          outlined
                          dense
                          placeholder="Vehicle Model"
                          persistent-hint
                          single-line hint="Enter the vehicle model">
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="vehicle.vehiclelicense"
                          v-bind:error="errorindex == 4"
                          outlined
                          dense
                          placeholder="License Number"
                          persistent-hint
                          single-line hint="Enter the license number">
                        </v-text-field>
                      </v-form>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">&nbsp;</p>
                        <v-select
                          outlined
                          dense
                          persistent-hint
                          class="mb-4"
                          placeholder="Location"
                          single-line
                          hint="Please choose the location"
                          v-bind:error="errorindex == 5"
                          :items="locations.filter(x=>x.locationstatus=='Active').map((x) => {return { text: x.locationname, value: x._id };})"
                          v-model="vehicle.locationid"
                        >
                        </v-select>
                        <v-select
                          outlined
                          dense
                          persistent-hint
                          class="mb-4"
                          placeholder="Driver"
                          single-line
                          hint="Please choose the driver"
                          v-bind:error="errorindex == 6"
                          :items="users.filter(x=>x.userstatus=='Active' && x.locationid==vehicle.locationid).map((x) => {return { text: x.username, value: x._id };})"
                          v-model="vehicle.driverid"
                        >
                        </v-select>
                        <v-select
                          outlined
                          dense
                          persistent-hint
                          class="mb-4"
                          placeholder="Loader"
                          single-line
                          hint="Please choose the loader"
                          v-bind:error="errorindex == 7"
                          :items="users.filter(x=>x.userstatus=='Active' && x.locationid==vehicle.locationid).map((x) => {return { text: x.username, value: x._id };})"
                          v-model="vehicle.loaderid"
                        >
                        </v-select>
                      </v-form>
                    </v-col>
                  </v-row>
                  <v-row justify="center">
                    <v-col cols="12" md="9">
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/vehicle/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            class="button-shadow"
                            color="primary"
                            @click="checkError">
                            Next
                          </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>

              <v-stepper-content step="2">
                <v-card>
                  <v-row justify="center">
                    <v-col cols="12" md="6">
                      <v-form>
                        <p class="text-h5">Upload Photo</p>
                        <p>Photo:</p>

                        <v-file-input label="File input" v-on:change="onFileChange" accept="image/*" />
                        <v-img contain max-height="150" max-width="250" :src="imageurl" />
                        <v-spacer min-height="20">&nbsp;</v-spacer>
                        <div class="d-flex justify-center">
                          <v-btn
                            outlined
                            color="primary"
                            @click="step = 1"
                          >
                            Back
                          </v-btn>
                          <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="createVehicle()">
                            Save
                          </v-btn>
                        </div>
                      </v-form>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
            </v-stepper-items>
          </v-card>

        </v-stepper>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';

export default {
  data () {
    return {
      step: 1,
      imageurl: undefined,
      vehicle: {
        vehiclestatus: 'Active'
      },
      items: ['Box Truck', 'Car', 'Rickshaw', 'Van'],
      error: undefined,
      haserror: false,
      errorindex: undefined,
    }
  },
  methods: {
    ...mapActions('Location', ['getLocationsRequest']),
    ...mapActions('Vehicle', ['insertVehicleRequest','getVehiclesRequest']),
    ...mapActions('User', ['getUsersRequest']),
    checkError(){
      if(!this.vehicle.vehiclecode){
        this.haserrors = true;
        this.errorindex = 0;
        return false;
      }
      if(!this.vehicle.vehiclename){
        this.haserrors = true;
        this.errorindex = 1;
        return false;
      }
      if(!this.vehicle.vehicletype){
        this.haserrors = true;
        this.errorindex = 2;
        return false;
      }
      if(!this.vehicle.vehiclemodel){
        this.haserrors = true;
        this.errorindex = 3;
        return false;
      }
      if(!this.vehicle.vehiclelicense){
        this.haserrors = true;
        this.errorindex = 4;
        return false;
      }
      if(!this.vehicle.locationid){
        this.haserrors = true;
        this.errorindex = 5;
        return false;
      }
      if(!this.vehicle.driverid){
        this.haserrors = true;
        this.errorindex = 6;
        return false;
      }
      if(!this.vehicle.loaderid){
        this.haserrors = true;
        this.errorindex = 7;
        return false;
      }
      this.errorindex = -1;
      this.step = 2;
      return true;
    },
    async createVehicle() {
      await this.insertVehicleRequest(this.vehicle);
      router.push('/vehicle/list')
    },
    createImage(file) {
      const reader = new FileReader();
      reader.onload = e => {
        this.imageurl = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    onFileChange(file) {
      if (!file) {return;}
      this.vehicle.vehicleimage = file;
      this.vehicle.imagename = file.name;
      this.createImage(file);
    }
  },
  computed: {
    ...mapState("Location", ["locations"]),
    ...mapState('Vehicle', ['isReceiving']),
    ...mapState("User", ["users"]),
  },
  async created () {
    if(this.locations.length==0) await this.getLocationsRequest();
    if(this.users.length==0) await this.getUsersRequest();
  },

}
</script>

<style src="./Add.scss" lang="scss"></style>
